import styled from 'styled-components';

export const SubsUsersTableContainer = styled.div`
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .pickerContainer {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .pickerFooter {
      display: flex;
      gap: 1rem;
      align-items: center;
      justify-content: space-between;

      .licences {
        display: flex;
        flex-direction: column;

        span {
          font: 400 0.8rem/1rem 'Roboto', sans-serif;
          color: ${({ theme }: {theme: any}) => theme.neutralTertiary};

          &.nonAvailable {
            color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
            font-weight: 600;
          }
        }
      }
    }
  }

  .tableContainer {
    display: flex;
    flex-direction: column;

    .filterInput {
      margin-top: 1rem;
      padding: 0.2rem 1rem;
      border: 2px solid ${({ theme }: {theme: any}) => theme.neutralQuaternaryAlt};
      background: ${({ theme }: {theme: any}) => theme.neutralLighterAlt};
      color: ${({ theme }: {theme: any}) => theme.black};
      border-radius: 8px;

      .filterInput:focus-visible {
        border: 2px solid ${({ theme }: {theme: any}) => theme.themePrimary};
        svg {
          color: ${({ theme }: {theme: any}) => theme.themePrimary};
        }
      }
    }
  }
`;
